import { Alert } from '@/shared/components/rebranded/Alert/Alert';
import { Status } from '../hooks/useDowntime/helper';

type Props = {
  serviceStatus: Status | undefined;
};

export const DowntimeStatus = ({ serviceStatus }: Props) => {
  if (serviceStatus) {
    const { title, message } = serviceStatus;

    return (
      <Alert fluid title={title} description={message} variant="warning" />
    );
  }

  return null;
};
